import styled, { css } from 'styled-components'

export const SwitcherContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<{
  $position?: {
    top?: string
    right?: string
    bottom?: string
    left?: string
  }
}>`
  ${({ $position }) =>
    $position &&
    css`
      position: absolute;
      ${$position.top && `top: ${$position.top};`}
      ${$position.right && `right: ${$position.right};`}
      ${$position.bottom && `bottom: ${$position.bottom};`}
      ${$position.left && `left: ${$position.left};`}
    `}
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows.md};
  padding: 4px;
  display: flex;
  gap: 4px;
  z-index: 5;
  width: fit-content;

  @media (max-width: 768px) {
    scale: 0.9;
  }
`

export const SwitcherOption = styled.button.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<{ $active?: boolean }>`
  padding: 8px 16px;
  border: none;
  background: transparent;
  border-radius: 8px;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.colors.primary};
      color: ${theme.colors.text.inverse};
    `}

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
  }
`
